<cw-navigation-drawer *transloco="let t">
  <div class="navigation-header">
    <div class="customer-name-container">
      @if (userConfigsFacade.canSwitchCountrySignal()) {
        <app-navigation-country-switch/>
      }
      <div class="d-flex align-items-center w-100">
        @if (!userConfigsFacade.canSwitchCountrySignal() &&
              userConfigsFacade.isInternalUserSignal() &&
              userConfigsFacade.currentCountrySignal()) {
          <div class="flag-container mr-s flex-shrink-0">
            <img
              fill
              [alt]="userConfigsFacade.currentCountrySignal()?.name"
              [ngSrc]="'https://purecatamphetamine.github.io/country-flag-icons/1x1/' +
                     userConfigsFacade.currentCountrySignal()?.code + '.svg'"/>
          </div>
        }
        <div class="customer-name">
          {{ t('B. Braun Technical Service') }}
        </div>
      </div>
    </div>
  </div>
  <cw-navigation-drawer-section>
    <a [routerLink]="overviewRoute" routerLinkActive #overviewLink="routerLinkActive"
      data-cy="overview-link-link">
      <cw-navigation-drawer-item
        icon="home"
        [label]="t('Overview')"
        font="material"
        [class.active]="overviewLink.isActive">
      </cw-navigation-drawer-item>
    </a>

    <a [routerLink]="processesRoute"
       [queryParams]="{ tableName: processTablesNames.ALL_INTERNAL }"
       [routerLinkActiveOptions]="{ exact: false }"
       routerLinkActive
       #allProcessesLink="routerLinkActive"
       data-cy="all-processes-link-link">
      <cw-navigation-drawer-item
        icon="all_inbox"
        [label]="t('All processes')"
        font="material"
        [class.active]="allProcessesLink.isActive">
      </cw-navigation-drawer-item>
    </a>

    <cw-navigation-drawer-group [heading]="t('Statuses')"
                                icon="local_offer"
                                font="material"
                                [expanded]="(isStatusesPanelExpanded$ | async)!">
      <a [routerLink]="processesRoute"
         [queryParams]="{ status: ProcessStatuses.NEW, tableName: processTablesNames.NEW_INTERNAL }"
         routerLinkActive
         #newlyCreatedLink="routerLinkActive"
         data-cy="newly-created-link-link">
        <cw-navigation-drawer-item
          [label]="t('Newly created')"
          font="material"
          [class.active]="newlyCreatedLink.isActive">
        </cw-navigation-drawer-item>
      </a>

      <a [routerLink]="processesRoute"
         [queryParams]="{ status: ProcessStatuses.READY_FOR_SHIPMENT, tableName: processTablesNames.READY_FOR_SHIPMENT_INTERNAL }"
         routerLinkActive
         #readyForShipmentLink="routerLinkActive"
         data-cy="ready-for-shipment-link-link">
        <cw-navigation-drawer-item
          [label]="t('Ready for shipment')"
          font="material"
          [class.active]="readyForShipmentLink.isActive">
        </cw-navigation-drawer-item>
      </a>

      <a [routerLink]="processesRoute"
         [queryParams]="{ status: ProcessStatuses.PICKUP_SCHEDULED, tableName: processTablesNames.PICKUP_SCHEDULED_INTERNAL }"
         routerLinkActive
         #pickupScheduledLink="routerLinkActive"
         data-cy="pickup-scheduled-link-link">
        <cw-navigation-drawer-item
          [label]="t('Pickup scheduled')"
          font="material"
          [class.active]="pickupScheduledLink.isActive">
        </cw-navigation-drawer-item>
      </a>

      <a [routerLink]="processesRoute"
         [queryParams]="{ status: ProcessStatuses.SENT, tableName: processTablesNames.SENT_INTERNAL }"
         routerLinkActive
         #sentToUsLink="routerLinkActive"
         data-cy="sent-to-us-link-link">
        <cw-navigation-drawer-item
          [label]="t('Sent to us')"
          font="material"
          [class.active]="sentToUsLink.isActive">
        </cw-navigation-drawer-item>
      </a>

      <a [routerLink]="processesRoute"
         [queryParams]="{ status: ProcessStatuses.IN_PROGRESS, tableName: processTablesNames.IN_PROGRESS_INTERNAL }"
         routerLinkActive
         #inProgressLink="routerLinkActive"
         data-cy="in-progress-link-link">
        <cw-navigation-drawer-item
          [label]="t('In progress')"
          font="material"
          [class.active]="inProgressLink.isActive">
        </cw-navigation-drawer-item>
      </a>

      <a [routerLink]="processesRoute"
         [queryParams]="{ status: ProcessStatuses.IN_WORKSHOP, tableName: processTablesNames.IN_WORKSHOP_INTERNAL }"
         routerLinkActive
         #inWorkshopLink="routerLinkActive"
         data-cy="in-workshop-link-link">
        <cw-navigation-drawer-item
          [label]="t('In workshop')"
          font="material"
          [class.active]="inWorkshopLink.isActive">
        </cw-navigation-drawer-item>
      </a>

      <a [routerLink]="processesRoute"
         [queryParams]="{ status: ProcessStatuses.APPROVAL_REQUIRED, tableName: processTablesNames.APPROVAL_REQUIRED_INTERNAL }"
         routerLinkActive
         #approvalRequiredLink="routerLinkActive"
         data-cy="approval-required-link-link">
        <cw-navigation-drawer-item
          [label]="t('Approval required')"
          font="material"
          [class.active]="approvalRequiredLink.isActive">
        </cw-navigation-drawer-item>
      </a>

      <a [routerLink]="processesRoute"
         [queryParams]="{ status: ProcessStatuses.REJECTED, tableName: processTablesNames.REJECTED_INTERNAL }"
         [routerLinkActiveOptions]="{ exact: false }"
         routerLinkActive
         #rejectedLink="routerLinkActive"
         data-cy="rejected-link-link">
        <cw-navigation-drawer-item
          [label]="t('Rejected')"
          font="material"
          [class.active]="rejectedLink.isActive">
        </cw-navigation-drawer-item>
      </a>

      <a [routerLink]="processesRoute"
         [queryParams]="{ status: ProcessStatuses.APPROVED, tableName: processTablesNames.APPROVED_INTERNAL }"
         [routerLinkActiveOptions]="{ exact: false }"
         routerLinkActive
         #approvedLink="routerLinkActive"
         data-cy="approved-link-link">
        <cw-navigation-drawer-item
          [label]="t('Approved')"
          font="material"
          [class.active]="approvedLink.isActive">
        </cw-navigation-drawer-item>
      </a>

      <a [routerLink]="processesRoute"
         [queryParams]="{ status: ProcessStatuses.BACKORDER, tableName: processTablesNames.BACKORDER_INTERNAL }"
         routerLinkActive
         #backordersLink="routerLinkActive"
         data-cy="backorders-link-link">
        <cw-navigation-drawer-item
          [label]="t('Backorders')"
          font="material"
          [class.active]="backordersLink.isActive">
        </cw-navigation-drawer-item>
      </a>

      <a [routerLink]="processesRoute"
         [queryParams]="{ status: ProcessStatuses.CANT_BE_SERVICED, tableName: processTablesNames.CANT_BE_SERVICED_INTERNAL }"
         routerLinkActive
         #cantBeServicedLink="routerLinkActive"
         data-cy="cant-be-serviced-link-link">
        <cw-navigation-drawer-item
          [label]="t('Can\'t be serviced')"
          font="material"
          [class.active]="cantBeServicedLink.isActive">
        </cw-navigation-drawer-item>
      </a>

      <a [routerLink]="processesRoute"
         [queryParams]="{ status: ProcessStatuses.READY_FOR_DELIVERY, tableName: processTablesNames.READY_FOR_DELIVERY_INTERNAL }"
         routerLinkActive
         #readyForDeliveryLink="routerLinkActive"
         data-cy="ready-for-delivery-link-link">
        <cw-navigation-drawer-item
          [label]="t('Ready for delivery')"
          font="material"
          [class.active]="readyForDeliveryLink.isActive">
        </cw-navigation-drawer-item>
      </a>

      <a [routerLink]="processesRoute"
         [queryParams]="{ status: ProcessStatuses.INTERNAL_SENT, tableName: processTablesNames.INTERNAL_SENT_INTERNAL }"
         routerLinkActive
         #sentToCustomerLink="routerLinkActive"
         data-cy="sent-to-customer-link-link">
        <cw-navigation-drawer-item
          [label]="t('Sent to customer')"
          font="material"
          [class.active]="sentToCustomerLink.isActive">
        </cw-navigation-drawer-item>
      </a>

      <a [routerLink]="processesRoute"
         [queryParams]="{ status: ProcessStatuses.RECEIVED, tableName: processTablesNames.RECEIVED_INTERNAL }"
         routerLinkActive
         #receivedLink="routerLinkActive"
         data-cy="received-link-link">
        <cw-navigation-drawer-item
          [label]="t('Received')"
          font="material"
          [class.active]="receivedLink.isActive">
        </cw-navigation-drawer-item>
      </a>
    </cw-navigation-drawer-group>
  </cw-navigation-drawer-section>

  <cw-navigation-drawer-section>
    <cw-navigation-drawer-group [heading]="t('Processes by type')" icon="label" font="material" [expanded]="true">
      <a [routerLink]="processesRoute"
         [queryParams]="{ type: ProcessType.REPAIR, tableName: processTablesNames.REPAIR_INTERNAL }"
         routerLinkActive
         #repairsLink="routerLinkActive"
         data-cy="repairs-link-link">
        <cw-navigation-drawer-item
          [label]="t('Repairs')"
          font="material"
          [class.active]="repairsLink.isActive">
        </cw-navigation-drawer-item>
      </a>

      @if (userConfigsFacade.swapEnabledSignal()) {
        <a [routerLink]="processesRoute"
          [queryParams]="{ type: ProcessType.SWAP, tableName: processTablesNames.SWAP_INTERNAL }"
          routerLinkActive
          #swapLink="routerLinkActive"
          data-cy="swap-link-link">
          <cw-navigation-drawer-item
            [label]="t('Swap')"
            font="material"
            [class.active]="swapLink.isActive">
          </cw-navigation-drawer-item>
        </a>
      }

      <a [routerLink]="processesRoute"
         [queryParams]="{ type: ProcessType.PURCHASE, tableName: processTablesNames.PURCHASE_INTERNAL }"
         [routerLinkActiveOptions]="{ exact: false }"
         routerLinkActive
         #purchasesLink="routerLinkActive"
         data-cy="purchases-link-link">
        <cw-navigation-drawer-item
          [label]="t('Purchases')"
          [badgeValue]="layoutStoreFacade.newPurchasesCountSignal()"
          font="material"
          [class.active]="purchasesLink.isActive">
        </cw-navigation-drawer-item>
      </a>

      <a [routerLink]="processesRoute"
         [queryParams]="{ type: ProcessType.REPAIR_REQUEST, tableName: processTablesNames.REPAIR_REQUEST_INTERNAL }"
         routerLinkActive
         #repairRequestLink="routerLinkActive"
         data-cy="repair-request-link-link">
        <cw-navigation-drawer-item
          [label]="t('Repair request')"
          font="material"
          [class.active]="repairRequestLink.isActive">
        </cw-navigation-drawer-item>
      </a>

      <a [routerLink]="processesRoute"
         [queryParams]="{ type: ProcessType.REPAIR_REPLACEMENT, tableName: processTablesNames.REPAIR_REPLACEMENT_INTERNAL }"
         routerLinkActive
         #repairReplacementsLink="routerLinkActive"
         data-cy="repair-replacements-link-link">
        <cw-navigation-drawer-item
          [label]="t('Repair replacements')"
          font="material"
          [class.active]="repairReplacementsLink.isActive">
        </cw-navigation-drawer-item>
      </a>

      <a [routerLink]="processesRoute"
         [queryParams]="{ type: ProcessType.SERVICE_NOT_POSSIBLE, tableName: processTablesNames.SERVICE_NOT_POSSIBLE_INTERNAL }"
         routerLinkActive
         #serviceNotPossibleLink="routerLinkActive"
         data-cy="service-not-possible-link-link">
        <cw-navigation-drawer-item
          [label]="t('Service not possible')"
          font="material"
          [class.active]="serviceNotPossibleLink.isActive">
        </cw-navigation-drawer-item>
      </a>
    </cw-navigation-drawer-group>

    <a [routerLink]="notificationsRoute"
      routerLinkActive
      #notificationsLink="routerLinkActive"
      data-cy="notifications-link-link">
      <cw-navigation-drawer-item
        icon="notifications"
        [label]="t('Notifications')"
        [badgeValue]="layoutStoreFacade.unreadNotificationsCountSignal()"
        font="material"
        [class.active]="notificationsLink.isActive">
      </cw-navigation-drawer-item>
    </a>

    <a [routerLink]="historyRoute"
       [queryParams]="{ tableName: processTablesNames.HISTORY_INTERNAL }"
       routerLinkActive
       #historyLink="routerLinkActive"
       data-cy="history-link-link">
      <cw-navigation-drawer-item
        icon="summarize"
        [label]="t('History')"
        font="material"
        [class.active]="historyLink.isActive">
      </cw-navigation-drawer-item>
    </a>

    <a [routerLink]="helpRoute"
      [routerLinkActiveOptions]="{ exact: false }"
      routerLinkActive
      #helpLink="routerLinkActive"
      data-cy="help-link-link">
      <cw-navigation-drawer-item
        icon="help"
        [label]="t('Help')"
        font="material"
        [class.active]="helpLink.isActive">
      </cw-navigation-drawer-item>
    </a>
  </cw-navigation-drawer-section>

  @if (userConfigsFacade.isAdminSignal()) {
    <cw-navigation-drawer-section>
      <a [routerLink]="settingsRoute"
         routerLinkActive
         #adminPanelLink="routerLinkActive"
         data-cy="admin-panel-link-link">
        <cw-navigation-drawer-item
          icon="settings"
          [label]="t('Settings')"
          font="material"
          [class.active]="adminPanelLink.isActive">
        </cw-navigation-drawer-item>
      </a>
    </cw-navigation-drawer-section>
  }
</cw-navigation-drawer>
